module.exports = __webpack_public_path__ + "img/megamenu.87e9e2ed.jpg";